/**
 * Admin Factories Page
 * Manage factory locations for the system
 */

import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { FactoriesSection } from '@ufc/domains/factories'

export const Route = createFileRoute('/admin/factories')({
  component: FactoriesPage,
})

function FactoriesPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          {t('admin.factories.title', 'Plant Management')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('admin.factories.subtitle', 'Manage manufacturing plants and production facilities')}
        </p>
      </div>
      <FactoriesSection />
    </div>
  )
}
